<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    class="heroicon-briefcase heroicon heroicons-lg"
  >
    <path
      class="heroicon-briefcase-case heroicon-component-fill"
      fill="#FFFFFF"
      d="M1 20a1 1 0 0 1 1-1h96a1 1 0 0 1 1 1v74a5 5 0 0 1-5 5H6a5 5 0 0 1-5-5V20z"
    ></path>
    <path
      class="heroicon-briefcase-flap-lip heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M4 19H1v35a11 11 0 0 0 11 11h76a11 11 0 0 0 11-11V19h-3v35a8 8 0 0 1-8 8H12a8 8 0 0 1-8-8V19z"
    ></path>
    <path
      class="heroicon-briefcase-strap heroicon-component-fill"
      fill="#FFFFFF"
      d="M57 62.76V56l-7-7-7 7v6.77A3 3 0 0 0 42 65v12.98A3 3 0 0 0 45 81h2c.82 0 1.84.42 2.42 1l.58.59.58-.59c.59-.58 1.6-1 2.42-1h2a3 3 0 0 0 3-3V65a3 3 0 0 0-1-2.24z"
    ></path>
    <path
      class="heroicon-briefcase-handle heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M64 16h-2v2h8v-2h-2V8a6 6 0 0 0-6-6H38a6 6 0 0 0-6 6v8h-2v2h8v-2h-2V8c0-1.1.9-2 2-2h24a2 2 0 0 1 2 2v8z"
    ></path>
    <path
      class="heroicon-briefcase-buckle heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M56 70h2v-5a3 3 0 0 0-3-3H45a3 3 0 0 0-3 3v5h2v3a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3v-3z"
    ></path>
    <path
      class="heroicon-shadows"
      fill="#000000"
      d="M88 70a12 12 0 0 0 12-12v-4a12 12 0 0 1-12 12H59v4h29zm-47 0H12A12 12 0 0 1 0 58v-4a12 12 0 0 0 12 12h29v4zm16 5a4 4 0 0 1-4 4h-6a4 4 0 0 1-4-4v-2a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4v2z"
      opacity=".2"
    ></path>
    <path
      class="heroicon-outline"
      fill="#4A4A4A"
      fill-rule="nonzero"
      d="M70 14h2v4h26a2 2 0 0 1 2 2v74a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V20c0-1.1.9-2 2-2h26v-4h2V8a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v6zm-2 2h-6v2h8v-2h-2zM32 8v6h1V8h1v6h2V8c0-1.1.9-2 2-2h24a2 2 0 0 1 2 2v6h1v-4h1v4h2V8a6 6 0 0 0-6-6H38a6 6 0 0 0-6 6zm30 6V8H38v6h2v4h20v-4h2zm-24 2h-8v2h8v-2zm22 4H5v34a7 7 0 0 0 7 7h31v-5l7-7 7 7v5h31a7 7 0 0 0 7-7V20H60zM2 20v34a10 10 0 0 0 10 10h29.13a4 4 0 0 0-.13 1v.01A4 4 0 0 1 42.36 62H12a8 8 0 0 1-8-8V20H2zm43 41h11v-4.59l-6-6-6 6V61h1zm14 4.01V65a4 4 0 0 0-.13-1H88a10 10 0 0 0 10-10V20h-2v34a8 8 0 0 1-8 8H57.65A4 4 0 0 1 59 65.01zM59 69v9a4 4 0 0 1-4 4h-2c-.55 0-1.31.31-1.71.71L50 84l-1.29-1.29c-.4-.4-1.15-.71-1.71-.71h-2a4 4 0 0 1-4-4V66H12c-4.17 0-7.85-2.13-10-5.36V94a4 4 0 0 0 4 4h88a4 4 0 0 0 4-4V60.63A11.99 11.99 0 0 1 88 66H59v3zm-2-3.99A2 2 0 0 0 55 63H45a2 2 0 0 0-2 2.01V69h14v-3.99zM43 71h-1v7a3 3 0 0 0 3 3h2c.82 0 1.84.42 2.42 1l.58.59.58-.59c.59-.58 1.6-1 2.42-1h2a3 3 0 0 0 3-3v-7h-1v2a4 4 0 0 1-4 4h-6a4 4 0 0 1-4-4v-2zm2 0v2c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2v-2H45zM11 24h46v.96H11V24zM5 66v28a1 1 0 0 0 1 1h46v1H6a2 2 0 0 1-2-2V66h1zm46 6v2h-2v-2h2z"
    ></path>
  </svg>
</template>
